import React from 'react';
import { scrollToBuy } from '../utils/constants';
type CtaButtonProps = {
  label?: string;
  className?: string;
  href?: string;
};
export function CtaButton({
  label = 'GET PADEL COACH PRO™ NOW',
  className = '',
  href
}: CtaButtonProps) {
  const base = 'inline-flex w-full max-w-xl items-center justify-center rounded-lg bg-brand px-5 py-3.5 text-center font-head text-sm font-bold uppercase leading-tight tracking-wide text-white shadow-lg shadow-brand/25 transition hover:bg-brand-dark active:scale-[0.99] sm:px-9 sm:text-lg';
  if (href) {
    return <a href={href} className={`${base} ${className}`} data-id="element-65" data-mp="ljmnsenlqcx1">
        {label}
      </a>;
  }
  return <button type="button" onClick={scrollToBuy} className={`${base} ${className}`} data-id="element-66" data-mp="vbabc4h1f9t8">
      {label}
    </button>;
}